export const sendEvent = (eventType, eventProperties) => {
  window.gtag("event", eventType, { ...eventProperties });
};
